﻿import { ComboboxEditor, ComboboxEditorOptions, Decorators, EditorProps, getRemoteData } from "@serenity-is/corelib";
import { RowServiceColumnItem } from "@/ServerTypes/RowServiceColumnItem";

@Decorators.registerEditor('Matrix.ServiceSelectEditor')
export class ServiceSelectEditor extends ComboboxEditor<any, any> {

    constructor(opt: EditorProps<ComboboxEditorOptions>) {
        super({...opt, autoComplete: true });

        const data = (getRemoteData("RowServiceColumnData") as RowServiceColumnItem[]);

        const addedServices = new Set<string>();
        for (const item of data) {
            for (const service of item.Services)
            {
                if (addedServices.has(service))
                    continue;

                addedServices.add(service);
                this.addOption(service, service);
            }
        }
    }
}